import { isFeatureVisible } from "./featureVisibility";
import { canSeeWfhNav } from "./workModeHelpers";

export const REQUEST_HUB_TAB_DEFS = [
  { id: "leave", label: "إجازة وإذن", feature: "leave" },
  { id: "overtime", label: "إضافي", feature: "overtime" },
  { id: "advance", label: "سلفة" },
  { id: "wfh", label: "عن بُعد", wfh: true },
];

export const REQUEST_HUB_PAGE_IDS = ["leave", "overtime", "advance", "wfh"];

export function filterRequestHubTabs({
  flags,
  workMode,
  workModeResolved = true,
  requestTab,
  user,
} = {}) {
  return REQUEST_HUB_TAB_DEFS.filter((tab) => {
    if (tab.feature && !isFeatureVisible(flags, tab.feature)) return false;
    if (tab.wfh) {
      if (!workModeResolved && requestTab === "wfh") return true;
      return canSeeWfhNav(
        workMode,
        user?.role,
        user?.backendRoles || [],
      );
    }
    return true;
  });
}

export function resolveRequestHubTab(requestTab, tabs) {
  if (requestTab && tabs.some((entry) => entry.id === requestTab)) {
    return requestTab;
  }
  return tabs[0]?.id || "leave";
}

/** Keep the hub on overtime/advance/wfh unless a tab was chosen explicitly. */
export function nextRequestTab(pageId, options = {}, currentTab = "leave") {
  if (options.tab) return options.tab;
  if (REQUEST_HUB_PAGE_IDS.includes(pageId) && pageId !== "leave") {
    return pageId;
  }
  return currentTab || "leave";
}
